<div [classList]="containerClassToAplly() + (hasGlobalMessages() ? '-global-message  global-message' : '')">

  <app-notification></app-notification>

  <app-global-message class="sticky-top"></app-global-message>

  @if (showAppHeader()) {
  <app-header class="sticky-top header"></app-header>
  }

  @if (isShopComponent()) {
  <app-shop-slider-banner [class.blur]="showCartPreview()"></app-shop-slider-banner>
  }

  @if (isShopComponent()) {
  <app-shop-bundle-list [class.blur]="showCartPreview()"></app-shop-bundle-list>
  }

  @if (isShopComponent()) {
  <app-shop-header [class.blur]="showCartPreview()"></app-shop-header>
  }

  @defer (when showAppCartPreview(); prefetch on idle) {
  @if (!isMobile()) {
  <div class="cart-preview"
    [ngClass]="{'cart-preview--height': !hasGlobalMessages(), 'cart-preview--height-global-message': hasGlobalMessages()}"
    [class.open]="showAppCartPreview()">
    <app-side-checkout></app-side-checkout>
  </div>
  }
  }

  @if(showAppCartPreview()){
  <div class="backdrop-cart-preview" (click)="showCartPreview.set(false)"></div>
  }

  <main class="main-container" appScrollToTop [class.header-showing]="showAppHeader() && !hasGlobalMessages()"
    [class.header-showing-global-message]="showAppHeader() && hasGlobalMessages()"
    [class.header-showing-hidden-sub-nav]="!shouldShowCategoriesBar() && !hasGlobalMessages()"
    [class.header-showing-hidden-sub-nav-global-message]="!shouldShowCategoriesBar() && hasGlobalMessages()"
    [class.mobile-main-container]="showMobileFooter()"
    [class.with-shop-nav-only]="isShopComponent() && isShopBannerHidden()"
    [class.blur]="showCartPreview() && !isMobile()" [class.hidden-mobile-footer]="!showMobileFooter()">
    <router-outlet />
  </main>

  @if (showMobileFooter()) {
  <app-mobile-footer-menu></app-mobile-footer-menu>
  }

  @if (loadingService.isShowGlobalLoading()) {
  <app-loading></app-loading>
  }

</div>
